import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { BrokerBuyLinks } from '@/enums/brokerBuySteps'
import { MotorTradeBuyLinks } from '@/enums/motorTradeBuySteps'

import CG_Logo from '../assets/images/cg_logo.png'

export default function Home() {
  return (
    <>
      <Container bsPrefix="container-fluid">
        <div className="d-flex align-items-center mt-3">
          <div className="logo">
            <img src={CG_Logo} alt="CG logo" />
          </div>
        </div>
      </Container>
      <div className="container container-body-sm">
        <h3>Products</h3>
        <ul>
          <li>
            <Link to={BrokerBuyLinks.Step1}>Commercial combined</Link>
          </li>
          <li>
            <Link to={MotorTradeBuyLinks.Step1}>Motor Trade</Link>
          </li>
        </ul>
      </div>
    </>
  )
}
